import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import index from '../views/index.vue';
import aboutus from '../views/aboutus.vue';

const routes = [

  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: aboutus
  }
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  // history: createWebHashHistory(),
  routes
});

export default router;
